import RouterData from "./Routes";
import { ToastContainer } from "react-toastify";
import BuildUpdateAlert from "./Component/Modal/BuildUpdateAlert";
import AlertProfilePicModal from "./Component/AlertPicModal";
import { useModalSelector } from "./hooks/useModalSelector";
import ProfileImageCropModal from "./features/employeeManagement/components/modals/ProfileImageCropModal";
import { useAppSelector } from "./ReduxToolkit/Hooks";
import { setEmployeeProfileImage } from "./features/employeeManagement/redux/slice/EmployeeManagementSlice";
import { useEmployeeProfile } from "./hooks/useEmployeeProfile";

function App() {
  const { modalType, selectedId } = useModalSelector();
  const { employeeProfileDetails, loggedInEmployee } = useEmployeeProfile();
  const { employeeProfileImage } = useAppSelector(
    (state) => state.employeeManagement,
  );
  return (
    <>
      <RouterData />
      <ToastContainer />
      <BuildUpdateAlert />
      <AlertProfilePicModal />
      {modalType === "profileImageCropModal" &&
        employeeProfileImage &&
        !selectedId && (
          <ProfileImageCropModal
            setSelectedProfileImage={setEmployeeProfileImage}
            selectedProfileImage={employeeProfileImage}
            addedUserId={Number(employeeProfileDetails?.jobInformation?.userId)}
            employeeProfileDetails={employeeProfileDetails}
            loggedInEmployee={loggedInEmployee}
          />
        )}
    </>
  );
}

export default App;
